import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Row, Col, Form, Grid } from 'antd';

import { Evaluation, Informations, RequiredElements, UploadImage, Result, ActionPlan } from './Steps';
import { DIRECTION } from '@/components/ui/StepsNavigation/types';
import { StepsNavigation } from '@/components/ui/StepsNavigation';
import { useRosaContext } from './context';
import { StepsContainer } from './styles';

const { useFormInstance } = Form;

const steps = [
	{
		id: 'informations',
		name: 'informations',
		sequence: 0,
		description: I18n.get('General information'),
		component: <Informations />
	},
	{
		id: 'upload-image',
		name: 'upload-image',
		sequence: 1,
		description: I18n.get('Upload image'),
		component: <UploadImage />
	},
	{
		id: 'evaluation',
		name: 'evaluation',
		sequence: 2,
		description: I18n.get('Evaluation'),
		component: <Evaluation />
	},
	{
		id: 'required-elements',
		name: 'required-elements',
		sequence: 3,
		description: I18n.get('Required elements'),
		component: <RequiredElements />
	},
	{
		id: 'action-plan',
		name: 'action-plan',
		sequence: 4,
		description: I18n.get('Action plan'),
		component: <ActionPlan />
	},
	{
		id: 'results',
		name: 'results',
		sequence: 5,
		description: I18n.get('Results'),
		component: <Result />
	}
];

export function Content() {
	const form = useFormInstance();
	const breakpoints = Grid.useBreakpoint();
	const { currentStep, onUpdateStep, isConsolidated, isNextStepBlocked, isCompleted } = useRosaContext();

	async function handleStepChange(step: number): Promise<void> {
		if (isConsolidated) {
			return;
		}

		if (!isCompleted && step > currentStep + 1) {
			return;
		}

		if (isNextStepBlocked && step > currentStep) {
			return;
		}

		if (step > currentStep) {
			await form.validateFields();
		}

		onUpdateStep(step);
	}

	return (
		<Row gutter={[60, 0]}>
			<Col xs={24} xxl={5}>
				<StepsNavigation
					steps={steps}
					isComplete={isCompleted}
					currentStep={currentStep}
					onStepNagivationClick={handleStepChange}
					direction={!breakpoints.xxl ? DIRECTION.HORIZONTAL : DIRECTION.VERTICAL}
				/>
			</Col>
			<StepsContainer xs={24} xxl={19}>
				{steps[currentStep]?.component}
			</StepsContainer>
		</Row>
	);
}
